<script setup>
import { Inertia } from '@inertiajs/inertia';
import { defineProps, reactive, watch, ref} from 'vue';
import ArrowLeftIcon from "@/Shared/SVG/ArrowLeftIcon";

let props = defineProps({
    position: Object,
    candidate: Object,
});

let position = (props.position)?props.position.data:null
let candidate = props.candidate.data
</script>

<template>
    <div class="max-w-7xl mx-auto px-4 flex justify-between items-center">
        <h1 class="text-2xl font-semibold text-gray-900">Candidates</h1>
        <Link href="/backoffice/candidates" class="text-sm text-wgn-blue-4 flex items-baseline"><ArrowLeftIcon class="mr-1 w-3 h-3"></ArrowLeftIcon>Back To Candidates</Link>
    </div>
    <hr class="my-3">
    <div class="max-w-7xl mx-auto px-4 text-sm">
        <div>
            <div class="mt-2">
                <label for="title" class="font-bold">ID</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.id}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Position</label>
                <p v-if="position" class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.id}}</p>
                <p v-else class="w-full px-4 py-2 mt-1 border rounded-md ">Undefined</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">First Name</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.first_name}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Last Name</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.last_name}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Email</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.email}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Phone</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.phone}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Linkedin Link</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.linkedin_link}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Additional Link</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.additional_link}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Status</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">{{candidate.status}}</p>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Attachment</label>
                <p class="w-full px-4 py-2 mt-1 border rounded-md ">
                    <a :href="candidate.attachment_url" target="_blank" class="text-blue-800" >{{candidate.attachment}}</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import BackofficeLayout from '@/Layouts/BackofficeLayout'
export default {
    layout: BackofficeLayout,
}
</script>
